<script lang="ts">
  import type { Snippet } from 'svelte';
  import type { ClassValue } from 'svelte/elements';

  let {
    header,
    children,
    open = $bindable(false),
    dialogClass,
    modalBoxClass,
  }: {
    header?: Snippet | string;
    children?: Snippet;
    open?: boolean;
    dialogClass?: ClassValue;
    modalBoxClass?: ClassValue;
  } = $props();
</script>

<dialog
  class={['modal', dialogClass]}
  closedby="closerequest"
  {open}
  onclose={() => (open = false)}
  onclick={(e) => e.target === e.currentTarget && e.currentTarget.close()}
>
  <div class={['modal-box', modalBoxClass]}>
    {#if typeof header === 'string'}
      <h3 class="mb-4 text-xl font-bold">
        {header}
      </h3>
    {:else}
      {@render header?.()}
    {/if}
    {@render children?.()}
  </div>
</dialog>
